import React from "react";
import { formatCurrency } from "../../../../utils/moneyFormat";
import { PaymentDetailField } from "./PaymentDetailField";
import { PaymentDetailProps } from "../interfaces";

export const PaymentDetail: React.FC<PaymentDetailProps> = ({
  code,
  fields,
  title,
  total,
}) => {
  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b border-gray-200 p-4">
        <h3 className="text-base font-medium text-gray-800">
          {title}
          <span className="ml-2 text-sm font-normal text-gray-400">{code}</span>
        </h3>
        <p className="font-medium text-primary">{formatCurrency(total)}</p>
      </div>
      <div className="grid gap-x-6 gap-y-4 p-4 md:grid-cols-2">
        <div className="space-y-4">
          {fields.left
            .filter((field) => !(field.isConditional && !field.value))
            .map((field) => (
              <PaymentDetailField
                key={field.label}
                info={field.info}
                isCopyable={field.isCopyable}
                label={field.label}
                type={field.type}
                value={field.value}
              />
            ))}
        </div>
        <div className="space-y-4">
          {fields.right
            .filter((field) => !(field.isConditional && !field.value))
            .map((field) => (
              <PaymentDetailField
                key={field.label}
                info={field.info}
                isCopyable={field.isCopyable}
                label={field.label}
                type={field.type}
                value={field.value}
              />
            ))}
        </div>
      </div>
    </>
  );
};
